export default __webpack_public_path__ + "static/media/icon-access-anywhere.2856c661.svg";